export default (props) =>
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 57 57" {...props}>
        <g id="down" transform="translate(-251 -912)">
            <circle id="Ellipse_442" data-name="Ellipse 442" cx="28.5" cy="28.5" r="28.5" transform="translate(251 912)" />
            <g id="noun-arrow-1830606" transform="translate(187.34 783.808)">
                <path id="Path_32922" data-name="Path 32922" d="M113.114,161.248a1.094,1.094,0,0,1-.683-.287L103.9,153.09h0a1.1,1.1,0,1,1,1.49-1.606l7.782,7.181,7.782-7.181a1.1,1.1,0,1,1,1.49,1.606l-8.527,7.871h0a1.093,1.093,0,0,1-.806.287Z" transform="translate(-20.893)" fill="rgb(4, 15, 33)" stroke="transparent" />
            </g>
        </g>
    </svg>
